// This file is automatically generated. Do not edit manually.

import { SummaryView } from "src/api/generated/postgres/db/types/public_/tables/summaryView";
import { SummaryViewItem } from "src/api/generated/postgres/db/types/public_/tables/summaryViewItem";
import { SummaryViewService_DisplayData } from "src/api/generated/spc/summaryViews/summaryViewService";
import { SummaryViewItemView } from "src/api/generated/postgres/db/types/public_/tables/summaryViewItemView";
import { SummaryViewStore_SourceOption } from "src/api/generated/spc/summaryViews/summaryViewStore";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SummaryViewApi {
	export async function getSummaryViews(): Promise<Array<SummaryView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/getSummaryViews",
			method: "POST",
			data: {},
		});
		return response as Array<SummaryView>;
	}

	export async function saveSummaryView(args: { summaryView: SummaryView }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/saveSummaryView",
			method: "POST",
			data: {
				summaryView: args.summaryView,
			},
		});
		return response as number;
	}

	export async function deleteSummaryViews(args: { summaryViewIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/deleteSummaryViews",
			method: "POST",
			data: {
				summaryViewIds: args.summaryViewIds,
			},
		});
		return response as void;
	}

	export async function getSummaryViewItems(args: { summaryViewId: number }): Promise<SummaryViewApi_ItemsData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/getSummaryViewItems",
			method: "POST",
			data: {
				summaryViewId: args.summaryViewId,
			},
		});
		return response as SummaryViewApi_ItemsData;
	}

	export async function saveSummaryViewItem(args: { item: SummaryViewItem }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/saveSummaryViewItem",
			method: "POST",
			data: {
				item: args.item,
			},
		});
		return response as number;
	}

	export async function deleteSummaryViewItems(args: { summaryViewItemIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/deleteSummaryViewItems",
			method: "POST",
			data: {
				summaryViewItemIds: args.summaryViewItemIds,
			},
		});
		return response as void;
	}

	export async function getPermittedSummaryViews(): Promise<Array<SummaryView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/getPermittedSummaryViews",
			method: "POST",
			data: {},
		});
		return response as Array<SummaryView>;
	}

	export async function getDisplayData(args: { summaryViewId: number }): Promise<SummaryViewService_DisplayData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/spc/summaryViews/getDisplayData",
			method: "POST",
			data: {
				summaryViewId: args.summaryViewId,
			},
		});
		return response as SummaryViewService_DisplayData;
	}
}

export interface SummaryViewApi_ItemsData {
	items: Array<SummaryViewItemView>;
	nextPosition: number;
	sourceOptions: Array<SummaryViewStore_SourceOption>;
}
